import type { ReactNode } from 'react'
import Manifest, { type ManifestActiveSurface } from './Manifest'

interface TinKernHeaderProps {
  active?: ManifestActiveSurface
  brand?: ReactNode
  centerSlot?: ReactNode
  rightSlot?: ReactNode
  containerClassName?: string
  innerClassName?: string
  manifestProps?: React.ComponentProps<typeof Manifest>
}

export default function TinKernHeader({
  active,
  brand,
  centerSlot,
  rightSlot,
  containerClassName = 'sticky top-0 z-40 backdrop-blur-md bg-black/40 border-b border-white/10',
  innerClassName = 'max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-4',
  manifestProps,
}: TinKernHeaderProps) {
  return (
    <header className={containerClassName}>
      <div className={innerClassName}>
        <div className="flex-shrink-0">
          {brand ?? (
            <a
              href="https://labs.tinkernlabs.com"
              className="text-sm font-semibold tracking-wide text-white hover:opacity-80 transition-opacity"
            >
              TinKern Labs
            </a>
          )}
        </div>
        <div className="flex-1 flex items-center justify-center min-w-0">{centerSlot}</div>
        <div className="flex-shrink-0 flex items-center gap-2">
          {rightSlot}
          <Manifest active={active} {...manifestProps} />
        </div>
      </div>
    </header>
  )
}
